'use client';

import { useState, useEffect } from 'react';
import Link from "next/link";

export default function Footer() {
  const [settings, setSettings] = useState({
    siteName: '企业名称',
    siteEmail: 'info@example.com',
    sitePhone: '400-123-4567',
    siteAddress: '北京市朝阳区某某大厦',
    icpNumber: ''
  });

  useEffect(() => {
    // 获取设置
    const fetchSettings = async () => {
      try {
        const response = await fetch('/api/settings');
        if (!response.ok) {
          throw new Error('Failed to fetch settings');
        }
        const data = await response.json();
        setSettings(data);
      } catch (err) {
        console.error('Error fetching settings:', err);
      }
    };

    fetchSettings();
  }, []);

  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">{settings.siteName}</h3>
            <p className="text-white">专业的企业服务提供商，致力于为客户提供高品质的产品和服务。</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2">
              <li><Link href="/" className="text-white hover:text-gray-300 transition-colors">首页</Link></li>
              <li><Link href="/about" className="text-white hover:text-gray-300 transition-colors">关于我们</Link></li>
              <li><Link href="/products" className="text-white hover:text-gray-300 transition-colors">产品展示</Link></li>
              <li><Link href="/contact" className="text-white hover:text-gray-300 transition-colors">联系我们</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">联系方式</h3>
            <p className="text-white">电话：{settings.sitePhone}</p>
            <p className="text-white">邮箱：{settings.siteEmail}</p>
            <p className="text-white">地址：{settings.siteAddress}</p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-600 text-center text-white">
          <p>© 2026 {settings.siteName}. 保留所有权利.</p>
          {settings.icpNumber && (
            <p className="mt-2">
              <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-colors"
              >
                {settings.icpNumber}
              </a>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
